module.exports = __webpack_public_path__ + "img/genz-20.4c591f64.png";